
































import { Component, Vue, Prop } from 'vue-property-decorator';

import {
  IInternationalization,
  IInternationalizationStatus
} from '@/models/internationalization';
import { getCountryFlagFile } from '@/constants/countryFlags';

import { Typography, Picture } from '@/components/atoms';
import CheckIcon from '@/components/icons/Check.vue';

type TagInfo = {
  bg: string;
  label: string;
};

@Component({
  components: {
    Typography,
    Picture,
    CheckIcon
  }
})
export default class PhoneInputCountryItem extends Vue {
  @Prop({ required: true }) readonly country?: IInternationalization;
  @Prop() readonly selectedCountry?: IInternationalization;

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get isSelected() {
    return (
      this.selectedCountry &&
      this.country &&
      this.selectedCountry.countryIso2 === this.country.countryIso2
    );
  }

  get hasCountry() {
    return !!Object.keys(this.country || {}).length;
  }

  get countryFlagFile() {
    return getCountryFlagFile(this.country && this.country.countryIso2);
  }
}
